


































































































import Vue from 'vue'
import { getNestedValue } from '@/util/helpers'
import { areaTypeDisplayName } from '@/services/report/areaTypes'

interface Specification {
  areaType: {
    key: string
    displayName: string
  }
  transactionsCnt: number
  mean: {
    priceSquare: number
    priceTotal: number
  }
  median: {
    priceSquare: number
    priceTotal: number
  }
}

export default Vue.extend({
  computed: {
    areaType(): string {
      return this.$store.getters['valuationEdit/areaType']
    },
    isExtended(): boolean {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['apartmentLayoutExtension'],
        false
      )
    },
    otherSpecification(): any {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['otherSpecification'],
        {}
      )
    },
    specifications(): Specification[] {
      return Object.keys(this.otherSpecification)
        .filter(
          areaType =>
            areaTypeDisplayName(areaType).valid &&
            ((this.isExtended && areaType.endsWith('_extended')) ||
              (!this.isExtended && !areaType.endsWith('_extended')))
        )
        .sort()
        .map(areaType => ({
          areaType: {
            displayName: areaTypeDisplayName(areaType).value!,
            key: areaType,
          },
          transactionsCnt: getNestedValue(
            this.otherSpecification,
            [areaType, 'transactionsCnt'],
            0
          ),
          mean: {
            priceSquare: getNestedValue(
              this.otherSpecification,
              [areaType, 'mean', 'price'],
              0
            ),
            priceTotal: getNestedValue(
              this.otherSpecification,
              [areaType, 'mean', 'priceTotal'],
              0
            ),
          },
          median: {
            priceSquare: getNestedValue(
              this.otherSpecification,
              [areaType, 'median', 'price'],
              0
            ),
            priceTotal: getNestedValue(
              this.otherSpecification,
              [areaType, 'median', 'priceTotal'],
              0
            ),
          },
        }))
    },
  },
})
